import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {RecordData, RecordsDataRequestQueryParams, RecordTotalData} from "../../../../types/records-table.types";
import {baseUrl} from "../../../../constants/base-url";
import {advertisementPackagesResourceType} from "../configs/advertisement-packages-modal.config";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AdvertisementPackagesModalApiService {
  private http: HttpClient = inject(HttpClient);

  public getRecordsData(id: number): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${baseUrl}/${advertisementPackagesResourceType.path}/${id}/record-calendars`);
  }

  public getPackages(queryParams: RecordsDataRequestQueryParams): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${baseUrl}/${advertisementPackagesResourceType.path}/`, {
      params: queryParams
    });
  }

  public createPackages(packageName: string): Observable<RecordData> {
    return this.http.post<RecordData>(`${baseUrl}/${advertisementPackagesResourceType.path}`, {
      name: packageName
    });
  }

  public getAggregations(id: number): Observable<Array<RecordTotalData>> {
    return this.http.get<Array<RecordTotalData>>(`${baseUrl}/${advertisementPackagesResourceType.path}/${id}/record-calendars/columns-aggregation`);
  }
}
